<template>
  <ClientOnly>
    <span
      v-if="userIsAuthenticated"
      class="account-button account-button--text"
      :class="$attrs.class"
      @click="navigateToAccount"
    >
      <Icon
        name="custom:user-regular-full"
        size="16"
      />
      {{ $t('my_account') }}
    </span>
    <span
      v-else
      class="account-button account-button--text"
      :class="$attrs.class"
      @click="navigateToLogin"
    >
      <Icon
        name="custom:user-regular-full"
        size="16"
      />
      {{ $t('login') }}
    </span>

    <template #fallback>
      <span
        class="account-button account-button--text"
        :class="$attrs.class"
      >
        <Icon
          name="custom:user-regular-full"
          size="16"
        />
        {{ $t('login') }}
      </span>
    </template>
  </ClientOnly>
</template>

<script setup>
  import { storeToRefs } from 'pinia'
  import { useUserStore } from '~/stores/user'
  import { ROUTES } from '~/lib/constants/routes'

  const localePath = useLocalePath()
  const router = useRouter()
  const userStore = useUserStore()
  const { isAuthenticated: userIsAuthenticated } = storeToRefs(userStore)

  function navigateToAccount() {
    router.push({ path: localePath(ROUTES.ACCOUNT) })
  }

  function navigateToLogin() {
    router.push({ path: localePath(ROUTES.LOGIN) })
  }
</script>

<style lang="scss">
  .account-button {
    cursor: pointer;
  }

  .account-button--text {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .account-button--text.app-button {
    padding: 0;
  }

  .account-button--text .account-button__text {
    display: inline;
  }

  .account-button--text .account-button__icon {
    display: none;
  }

  .account-button__text {
    display: none;

    @include breakpoint(desktop) {
      gap: 4px;
    }
  }

  .account-button__icon {
    @include breakpoint(desktop) {
      display: none !important;
    }
  }
</style>
